// Опции передаются нативными children (<option selected={...}>),
// onChange получает нативный event — event.target.value.
export function Select({ header, onChange, className = "", children }) {
  return (
    <div className={`ui-input ui-select ${className}`}>
      {header && <span className="ui-input__label">{header}</span>}
      <div className="ui-input__field ui-select__field">
        <select className="ui-select__native" onChange={onChange}>
          {children}
        </select>
        <svg
          className="ui-select__chevron"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6 9l6 6 6-6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
}
